import { Title, TitleArea } from './Title';
export { Title, TitleArea };
